import { Pagination } from 'antd';
import styles from './DetailListTable.module.scss';
import { useMemo, useState } from 'react';
import Button from '@src/components/button/Button';
import CloseIcon from 'src/assets/icons/close.svg?react';
import { formatTimeFromSeconds } from '@src/utils/time';

type Props = {
    detailName: string;
    handleClose: () => void;
    detailList: any[];
}
const pageSize = 10;
function DetailListTable(props: Props) {
    const { detailName, detailList, handleClose } = props;
    const [current, setCurrent] = useState(1);
    const [minIndex, setMinIndex] = useState(0);
    const [maxIndex, setMaxIndex] = useState(pageSize);
    const handlePageChange = (page: number) => {
        setCurrent(page);
        setMinIndex((page-1) * pageSize);
        setMaxIndex(page * pageSize);
    }

    const total = useMemo(() => {
      return Math.max(...detailList.map((item) => item.value));
    }, [detailList]);

    return (
        <div className={styles.wrapper}>
            <div className={styles.detailHeader} >
                <div className={styles.detailName}>Name</div>
                <div className={styles.detailTitle}>
                    <span>{detailName === "Unique Logins" ? "Completed Lessons" : detailName}</span>
                    <Button label='Close' size='small' outline onClick={handleClose} className={styles.closeButton} rightIcon={<CloseIcon className={styles.closeIcon} />}/>
                </div>
            </div>
            {detailList.map((detail, index) => {
                if(index >= minIndex && index < maxIndex ) {
                    const progress = Math.ceil((detail.value / total) * 100);
                    return (
                        <div className={styles.detailView} >
                            <div className={styles.detailLabel}>{detail.name}</div>
                            <div className={styles.detailPercent}>
                                <div className={styles.flexBox}>
                                    <div className={styles.progressBackground}>
                                        <div className={styles.progressBar} style={{ width: `${progress}%`, background: progress > 0 ? '#BCDCDF': '#EDEDED' }} />
                                        <div className={styles.completedLessonsTitle} style={{width: detailName === 'Time Spent on Platform' ? 100 : 30}}>{detailName === 'Time Spent on Platform' ? formatTimeFromSeconds(detail.value) : detail.value}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                } else {
                    return null
                }
            })}
            <Pagination
                pageSize={pageSize}
                current={current}
                total={detailList.length}
                onChange={handlePageChange}
                className={styles.pagination}
                showSizeChanger={false}
          />
        </div>
    )
}
export default DetailListTable;